import React, { useState, useEffect } from "react";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import { SpinnerLoading } from "../../components/Loadings";
import { useNavigate } from "react-router-dom";
import { LOGO } from "../../Utility/static";
import { getContentfulData } from "../../Utility/ApiService";

const elementName = "TTAC";

const TermsAndCondition = () => {
  const [privacyData, setPrivacyData] = useState();
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    setLoading(true);
    getContentfulData(elementName)
      .then(async (response) => {
        setLoading(false);
        setPrivacyData(response);
      })
      .catch(async (err) => {
        console.log("err", err);
        setLoading(false);
      });
  }, []);

  return (
    <div>
      {loading && (
        <div className="loadingSpinner">
          <SpinnerLoading />
        </div>
      )}
      <div className="vertical-menu">
        <div className="sidebar">
          <div className="logo d-flex justify-content-center">
            <img src={LOGO} className="cursor-pointer" onClick={() => navigate("/")} alt="" />
          </div>
        </div>
      </div>
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <div className="privacy-policy" style={{ alignItems: "center", flex: 1 }}>
              {privacyData && documentToReactComponents(privacyData)}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsAndCondition;
